<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="110px"
        class="search_form"
        >
          <el-divider content-position="left">基础信息</el-divider>
          <el-form-item label="客户" prop="customerId">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.customerId"
            placeholder="请选择客户"
            clearable
            filterable
            @change="change_customerId"
            >
              <el-option
              v-for="item in customerId_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品" prop="sku">
            <el-input :readonly="true" @click.native="to_sku" placeholder="请选择产品" v-model="search_form.sku"></el-input>
          </el-form-item>
          <el-form-item label="批次" prop="lotNum">
            <el-input placeholder="请输入批次" v-model="search_form.lotNum"></el-input>
          </el-form-item>
          <el-form-item label="仓库" prop="wareHouseId">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.wareHouseId"
            placeholder="请选择仓库"
            clearable
            filterable
            >
              <el-option
              v-for="item in wareHouseId_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">批次属性</el-divider>
          <el-form-item
          v-show="item.status!=1"
          v-for="(item,index) in search_form.batch_list"
          :key="index"
          :label="item.lotName"
          :prop="'batch_list.'+index+'.lotAtt'">
            <el-input
            :type="item.lotName=='生产日期'||item.lotName=='有效期/失效期'||item.lotName=='入库日期'?'date':'text'"
            v-model="item.lotAtt"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            icon="el-icon-search"
            @click="search_query"
            v-if="btn_permission.includes('wms:stock:inventoryList')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            @click="reset_query"
            v-if="btn_permission.includes('wms:stock:inventoryList')||btn_permission.includes('superAdmin')"
            >重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 选择产品弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="productVisible"
        title="选择产品"
        width="60%"
        >
          <el-form :inline="true">
            <el-form-item label="关键字">
              <el-input placeholder="物料编码/名称/原厂编码" v-model="productKey"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search_product">搜索</el-button>
            </el-form-item>
          </el-form>
          <!-- 产品列表 -->
          <el-table
          :data="product_data"
          highlight-current-row
          border
          max-height="400"
          @row-dblclick="db_product"
          >
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="sku"
            label="物料编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descrC"
            label="物料描述"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descrE"
            label="规格"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="reservedField04"
            label="原厂编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="skuGroup3"
            label="供应商"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="skuGroup4"
            label="存储"
            ></el-table-column>
          </el-table>
          <!-- 产品列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="product_size_change"
          @current-change="product_current_change"
          :current-page="product_current_page"
          :page-sizes="[10,15,20,25]"
          :page-size="product_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product_total"
          ></el-pagination>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 库存列表 -->
        <el-table
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        >
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="customerName"
          label="客户"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="sku"
          label="产品"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="descrC"
          label="中文名称"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="descrE"
          label="规格"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="lotNum"
          label="批次"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="reservedField04"
          label="原厂编码"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="qty"
          label="库存数量"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="canUseQty"
          label="可用数量"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="qtyOnHold"
          label="冻结数量"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseId"
          label="所属仓库"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="lotAtt01"
          label="生产日期"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="lotAtt02"
          label="有效期"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="lotAtt04"
          label="产品批号"
          ></el-table-column>
        </el-table>
        <!-- 库存列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="query_size_change"
        @current-change="query_current_change"
        :current-page="query_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="query_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="query_total"
        ></el-pagination>
        <el-button
        type="primary"
        icon="el-icon-download"
        @click="export_data"
        v-if="btn_permission.includes('wms:stock:exportInventory')||btn_permission.includes('superAdmin')"
        >导出Excel</el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //客户下拉框
        customerId_list:[],
        //仓库下拉框
        wareHouseId_list:[],
        //查询表单
        search_form:{
          customerId:'',
          sku:'',
          lotNum:'',
          wareHouseId:'',
          batch_list:[]
        },
        //选择产品弹框
        productVisible:false,
        productKey:'',
        product_data:[],
        product_current_page:1,
        product_page_size:10,
        product_total:0,
        //库存列表
        list_data:[],
        //库存列表懒加载
        list_loading:false,
        //库存列表分页
        query_current_page:1,
        query_page_size:10,
        query_total:0
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //客户下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/customer'
      }).then(data=>{
        if(data.data.success==true){
          that.customerId_list=data.data.data
        }
      })
      //仓库下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/warehouse'
      }).then(data=>{
        if(data.data.success==true){
          that.wareHouseId_list=data.data.data
        }
      })
    },
    mounted() {

    },
    methods:{
      //选择产品弹框
      to_sku(){
        this.productVisible=true
        //获取产品列表
        this.get_product()
      },
      //获取产品列表
      get_product(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/basSku/list',
          params:{
            page:that.product_current_page,
            limit:that.product_page_size,
            sku:that.productKey,
            customerId:'',
            activeFlag:'',
            descrC:'',
            reservedField04:''
          }
        }).then(data=>{
          if(data.data.success==true){
            that.product_data=data.data.data.list
            that.product_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //双击产品列表
      db_product(row,column,event){
        this.productVisible=false
        this.search_form.sku=row.sku
      },
      //查询产品列表
      search_product(){
        this.product_current_page=1
        this.product_page_size=10
        //获取产品列表
        this.get_product()
      },
      //产品列表分页
      product_current_change(val){
        this.product_current_page=val
        //获取产品列表
        this.get_product()
      },
      product_size_change(val){
        this.product_page_size=val
        //获取产品列表
        this.get_product()
      },
      //选择客户change事件
      change_customerId(value){
        if(value){
          //获取批次属性列表
          this.get_batch(value)
        }else{
          this.search_form.batch_list=[]
        }
      },
      //获取批次属性列表
      get_batch(customerId){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/orderBase/lot/'+customerId
        }).then(data=>{
          if(data.data.success==true){
            that.search_form.batch_list=data.data.data
            that.search_form.batch_list.forEach(item=>{
              that.$set(item,'lotAtt','')
            })
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //获取库存查询列表
      get_query(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/stock/inventoryList',
          params:{
            page:that.query_current_page,
            limit:that.query_page_size,
            customerId:that.search_form.customerId,
            sku:that.search_form.sku,
            lotNum:that.search_form.lotNum,
            wareHouseId:that.search_form.wareHouseId,
            lotAtt01:that.search_form.batch_list.length==0?'':that.search_form.batch_list[0].lotAtt,
            lotAtt02:that.search_form.batch_list.length==0?'':that.search_form.batch_list[1].lotAtt,
            lotAtt03:that.search_form.batch_list.length==0?'':that.search_form.batch_list[2].lotAtt,
            lotAtt04:that.search_form.batch_list.length==0?'':that.search_form.batch_list[3].lotAtt,
            lotAtt05:that.search_form.batch_list.length==0?'':that.search_form.batch_list[4].lotAtt,
            lotAtt06:that.search_form.batch_list.length==0?'':that.search_form.batch_list[5].lotAtt,
            lotAtt07:that.search_form.batch_list.length==0?'':that.search_form.batch_list[6].lotAtt,
            lotAtt08:that.search_form.batch_list.length==0?'':that.search_form.batch_list[7].lotAtt,
            lotAtt09:that.search_form.batch_list.length==0?'':that.search_form.batch_list[8].lotAtt,
            lotAtt10:that.search_form.batch_list.length==0?'':that.search_form.batch_list[9].lotAtt,
            lotAtt11:that.search_form.batch_list.length==0?'':that.search_form.batch_list[10].lotAtt,
            lotAtt12:that.search_form.batch_list.length==0?'':that.search_form.batch_list[11].lotAtt
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.query_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_query(){
        this.activeName='two'
        this.query_current_page=1
        this.query_page_size=10
        //获取库存查询列表
        this.get_query()
      },
      //重置查询表单
      reset_query(){
        this.$refs.search_form.resetFields()
        this.search_form.batch_list=[]
        this.query_current_page=1
        this.query_page_size=10
        //获取库存查询列表
        this.get_query()
      },
      //库存列表分页
      query_size_change(val){
        this.query_page_size=val
        //获取库存查询列表
        this.get_query()
      },
      query_current_change(val){
        this.query_current_page=val
        //获取库存查询列表
        this.get_query()
      },
      //导出库存余量
      export_data(){
        const loading=this.$loading({
          lock:true,
          text:'正在拼命导出，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        let that=this
        let url='/wms/stock/export/inventory?customerId='+that.search_form.customerId+'&sku='+that.search_form.sku
        +'&lotNum='+that.search_form.lotNum+'&wareHouseId='+that.search_form.wareHouseId
        +'&lotAtt01='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[0].lotAtt)
        +'&lotAtt02='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[1].lotAtt)
        +'&lotAtt03='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[2].lotAtt)
        +'&lotAtt04='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[3].lotAtt)
        +'&lotAtt05='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[4].lotAtt)
        +'&lotAtt06='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[5].lotAtt)
        +'&lotAtt07='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[6].lotAtt)
        +'&lotAtt08='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[7].lotAtt)
        +'&lotAtt09='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[8].lotAtt)
        +'&lotAtt10='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[9].lotAtt)
        +'&lotAtt11='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[10].lotAtt)
        +'&lotAtt12='+(that.search_form.batch_list.length==0?'':that.search_form.batch_list[11].lotAtt)
        that.$axios({
          url:that.publicAjax.extra_path+url,
          method:'get',
          responseType:'blob'
        }).then(data=>{
          if(data.data.success==false){
            that.$message.warning(data.data.message)
            loading.close()
          }else{
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(new Blob([data.data], {type:"application/vnd.ms-excel"}))
            link.style.display='none'
            let fname='库存余量.xls'
            link.setAttribute('download',fname)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
            loading.close()
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/store/query.vue